module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/07507a04e0986d806cbd3ec73c724143.png";